export default __webpack_public_path__ + "static/media/cake-logo-png.e1d4dec3.png";